import { render, staticRenderFns } from "./GooglePlacesAutocomplete.vue?vue&type=template&id=06b4f38f&"
import script from "./GooglePlacesAutocomplete.vue?vue&type=script&lang=js&"
export * from "./GooglePlacesAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports